export function titlePath(id: string): string {
  const separator = id.indexOf(":");
  if (separator < 1) return encodeURIComponent(id);
  return `${encodeURIComponent(id.slice(0, separator))}:${encodeURIComponent(id.slice(separator + 1))}`;
}

export function watchPath(id: string, episode?: number): string {
  return `/titles/${titlePath(id).replace(":", "/")}${episode ? `/${episode}` : ""}`;
}

